/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  Text,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { StrategyDecisionMakingData } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function StrategyDecisionMakingDataTargetAchievementPlanUpdateForm(
  props
) {
  const {
    id: idProp,
    strategyDecisionMakingData: strategyDecisionMakingDataModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    TargetAchievementPlanName: "",
    TargetAchievementPlanDescription: "",
  };
  const [TargetAchievementPlanName, setTargetAchievementPlanName] =
    React.useState(initialValues.TargetAchievementPlanName);
  const [
    TargetAchievementPlanDescription,
    setTargetAchievementPlanDescription,
  ] = React.useState(initialValues.TargetAchievementPlanDescription);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = strategyDecisionMakingDataRecord
      ? { ...initialValues, ...strategyDecisionMakingDataRecord }
      : initialValues;
    setTargetAchievementPlanName(cleanValues.TargetAchievementPlanName);
    setTargetAchievementPlanDescription(
      cleanValues.TargetAchievementPlanDescription
    );
    setErrors({});
  };
  const [
    strategyDecisionMakingDataRecord,
    setStrategyDecisionMakingDataRecord,
  ] = React.useState(strategyDecisionMakingDataModelProp);
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? await DataStore.query(StrategyDecisionMakingData, idProp)
        : strategyDecisionMakingDataModelProp;
      setStrategyDecisionMakingDataRecord(record);
    };
    queryData();
  }, [idProp, strategyDecisionMakingDataModelProp]);
  React.useEffect(resetStateValues, [strategyDecisionMakingDataRecord]);
  const validations = {
    TargetAchievementPlanName: [],
    TargetAchievementPlanDescription: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          TargetAchievementPlanName,
          TargetAchievementPlanDescription,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(
            StrategyDecisionMakingData.copyOf(
              strategyDecisionMakingDataRecord,
              (updated) => {
                Object.assign(updated, modelFields);
              }
            )
          );
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(
        overrides,
        "StrategyDecisionMakingDataTargetAchievementPlanUpdateForm"
      )}
      {...rest}
    >
      <Heading
        level={4}
        children="Target Achievement Plan"
        {...getOverrideProps(overrides, "SectionalElement0")}
      ></Heading>
      <Heading
        children="AASB S2 paragraph 14 a v."
        {...getOverrideProps(overrides, "SectionalElement00")}
      ></Heading>
      <Text
        children="Update this record that defines a plan to achieve any climate-related targets, including any greenhouse gas emissions targets. Note that this should relate to your climate-related targets."
        {...getOverrideProps(overrides, "SectionalElement1")}
      ></Text>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement2")}
      ></Divider>
      <TextField
        label="Name of target achievement plan (e.g. 2027 target achievement plan)"
        isRequired={false}
        isReadOnly={false}
        value={TargetAchievementPlanName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              TargetAchievementPlanName: value,
              TargetAchievementPlanDescription,
            };
            const result = onChange(modelFields);
            value = result?.TargetAchievementPlanName ?? value;
          }
          if (errors.TargetAchievementPlanName?.hasError) {
            runValidationTasks("TargetAchievementPlanName", value);
          }
          setTargetAchievementPlanName(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "TargetAchievementPlanName",
            TargetAchievementPlanName
          )
        }
        errorMessage={errors.TargetAchievementPlanName?.errorMessage}
        hasError={errors.TargetAchievementPlanName?.hasError}
        {...getOverrideProps(overrides, "TargetAchievementPlanName")}
      ></TextField>
      <TextAreaField
        label="Description of plan to achieve climate-related targets"
        isRequired={false}
        isReadOnly={false}
        value={TargetAchievementPlanDescription}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              TargetAchievementPlanName,
              TargetAchievementPlanDescription: value,
            };
            const result = onChange(modelFields);
            value = result?.TargetAchievementPlanDescription ?? value;
          }
          if (errors.TargetAchievementPlanDescription?.hasError) {
            runValidationTasks("TargetAchievementPlanDescription", value);
          }
          setTargetAchievementPlanDescription(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "TargetAchievementPlanDescription",
            TargetAchievementPlanDescription
          )
        }
        errorMessage={errors.TargetAchievementPlanDescription?.errorMessage}
        hasError={errors.TargetAchievementPlanDescription?.hasError}
        {...getOverrideProps(overrides, "TargetAchievementPlanDescription")}
      ></TextAreaField>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement3")}
      ></Divider>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || strategyDecisionMakingDataModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || strategyDecisionMakingDataModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
